import React from "react";
import { Row, Col, Tag } from "antd";

const SliderTitle = ({ title, data, color, unit, colorTitle='#eee' }) => (
  <Row style={{ alignItems: "center" }}>
    <Col span={18}>
      <h4 style={{ color: colorTitle}}>
 
        {title} ({unit})
      </h4>
    </Col>
    <Col span={6} style={{ textAlign: "right" }}>
      <Tag
        variant="solid"
        color={color}
        style={{ fontSize: 14, padding: "2px 12px" }}
      >
        {data} {unit}
      </Tag>
    </Col>
  </Row>
);

export default SliderTitle;
